import BoardColumnEntity from "../../board_column/entity";
import * as bootstrap from 'bootstrap';
import Utils from '../../../utils';
import DefaultController from "../../defaultController";
import BoardEntity from "../entity";

declare const jKanban: any;

export default class BoardShow extends DefaultController {
    private kanbans: any = {};
    private addModal: any;
    private editModal: any;
    private boards: any = {};
    private customers: any[] = [];

    constructor() {
        super();
        this.addModal = bootstrap.Modal.getOrCreateInstance((document.querySelector("#ticketBoardAddBoard") as HTMLElement))
        this.editModal = bootstrap.Modal.getOrCreateInstance((document.querySelector("#ticketBoardConfig") as HTMLElement))

    }

    async init(): Promise<void> {
        this.entity = "tickets/boards";
        this.bindListeners();
        if (this.id) {
            await this.getEntity();
            await Utils.showLoader();
        } else {
            await Utils.createSelects(
                this.data,
                (elem: any) => this.onSelectGetFilterOptions(elem),
                (data: any, entity: any, element: any) => this.onSelectFilterResults(data, entity, element)
            );
        }
        await Utils.hideLoader();
    }

    protected getEntityData(elem: any): any {
        return BoardEntity.getEntityData(elem);
    }

    bindListeners(): void {
        (document.querySelector("#ticketBoardAddBoardForm") as HTMLFormElement).addEventListener("submit", async (e) => {
            e.preventDefault();
            const form = document.querySelector("#ticketBoardAddBoardForm") as HTMLFormElement;
            if (form.checkValidity()) {
                await Utils.showLoader()
                await Utils.entity.upsert({
                    ...BoardColumnEntity.getEntityData(form),
                    board_id: this.id
                }, "tickets/board_columns");
                if (this.addModal) {
                    this.addModal.hide();
                    await this.getEntity();
                }
                await Utils.hideLoader()
            }
        });
        (document.querySelector("#ticketBoardConfigBoardForm") as HTMLFormElement).addEventListener("submit", async (e: any) => {
            e.preventDefault();
            const form = document.querySelector("#ticketBoardConfigBoardForm") as HTMLFormElement;
            if (form.checkValidity()) {
                await Utils.showLoader()
                await Utils.entity.upsert({
                    ...BoardEntity.getEntityData(form),
                    uuid: this.id
                }, "tickets/boards");
                await this.getEntity();
                if (this.editModal) {
                    this.editModal.hide();
                }
                await Utils.hideLoader()
            }
        });
    }

    async setupBoard(): Promise<void> {
        if (Object.values(this.kanbans).length > 0) {
            this.kanbans = {};
            if (document.querySelectorAll(".kanban-wrapper")) {
                document.querySelectorAll(".kanban-wrapper").forEach((elem: any) => {
                    elem.innerHTML = "";
                })
            }
        }
        this.customers.concat([{uuid: "DEFAULT"}]).forEach((customer: any) => {
            console.log("customer.id", customer)
            this.kanbans[customer.uuid] = new jKanban({
                element: `.row[data-customer-id='${customer.uuid}'] .kanban-wrapper`,
                gutter: '15px',
                widthBoard: '250px',
                dragItems: true,
                boards: this.boards[customer.uuid],
                dragBoards: true,
                addItemButton: false,
                click: (el: HTMLElement) => this.onTaskClick(el),
                dropBoard: (el: HTMLElement) => this.onMoveColumn(el),
                dropEl: async (el: HTMLElement, target: HTMLElement) => { return await this.onMoveTicket(el, target)}
            })
        })

        this.setupBoardInteractions();
        document.querySelectorAll(".kanban-drag").forEach((elem: any) => {
            elem.style.textAlign = "center"
            elem.innerHTML += `<div class="spinner-border spinner-border-lg text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>`
        })
    }

    private async onMoveTicket(el: HTMLElement, target: HTMLElement) {
        const ticketId = el.getAttribute("data-eid");
        const ticket = (await Utils.entity.get(ticketId, "tickets", null, null, true)).data[0]
        const colId = (el.closest(".kanban-board") as HTMLElement).getAttribute("data-id")
        const statusId = this.boards[ticket.customer.uuid].filter(c => c.id === colId)[0].status_id
        if (ticket.status.to.map(s => s.id).indexOf(statusId) === -1 && 1 > 2) {
            this.toastr.error(`${Utils.translate('ticket.name')} ${Utils.translate('board.messages.not_moved')}`, `${Utils.translate('generic.error')}`)
            return false;
        } else {
            await Utils.entity.move({uuid: ticket.uuid, status_id: statusId}, "tickets")
            return true;
        }
    }

    private async onMoveColumn(el: HTMLElement): Promise<void> {
        setTimeout(async () => {
            console.log("el", el)
            const row = el.closest(".row [data-customer-id='DEFAULT']") as HTMLElement
            if (row.getAttribute("data-customer-id") === "DEFAULT") {
                // @ts-ignore
                const map = Array.from(row.querySelectorAll(".kanban-container .kanban-board")).map(e => {
                    return {id: e.getAttribute("data-id"), index: e.getAttribute("data-order") - 1}
                })
                for (const elem of map) {
                    await Utils.entity.upsert({uuid: elem.id, index: elem.index}, "tickets/board_columns");
                }
                await this.getEntity();
            }
        }, 300)
    }

    private onTaskClick(elem: HTMLElement): void {
        const id = elem.closest('.kanban-item')?.getAttribute('data-eid');
        document.location.href = `/${(window as any).currentLocale}/ticket/tasks/${id}`
    }

    private setupBoardInteractions(): void {
        const kanbanTitleBoard = Array.from(document.querySelectorAll('.kanban-title-board')) as HTMLElement[];
        kanbanTitleBoard.forEach((elem) => {
            elem.addEventListener('mouseenter', () => {
                elem.contentEditable = 'true';
            });
            elem.addEventListener("keyup", async (e) => {
                const id = elem.closest('.kanban-board')?.getAttribute('data-id');
                await Utils.entity.upsert({uuid: id, name: elem.innerHTML}, "tickets/board_columns");
            })
            elem.insertAdjacentHTML('afterend', this.renderBoardDropdown());
        });

        const deleteBoards = Array.from(document.querySelectorAll('.delete-board')) as HTMLElement[];
        deleteBoards.forEach((elem) => {
            elem.addEventListener('click', async (e: any) => {
                const id = elem.closest('.kanban-board')?.getAttribute('data-id');
                await Utils.entity.destroy(id, "tickets/board_columns");
                if (id) {
                    Object.values(this.kanbans).forEach((kanban: any) => {
                        kanban.removeBoard(id);
                    })
                }
            });
        });
    }

    private renderBoardDropdown(): string {
        return `
            <div class='dropdown'>
                <i class='dropdown-toggle ti ti-dots-vertical cursor-pointer' data-bs-toggle='dropdown'></i>
                <div class='dropdown-menu dropdown-menu-end'>
                    <a class='dropdown-item delete-board' href='javascript:void(0)'>
                        <i class='ti ti-trash ti-xs me-1'></i> Delete
                    </a>
                </div>
            </div>
        `;
    }


    generateBoardInfo() {
        this.boards = {}
        this.customers.concat([{uuid: "DEFAULT"}]).forEach((customer: any) => {
            this.boards[customer.uuid] = []
            this.data.columns.sort((a: any, b: any) => a.index - b.index).forEach((col: any) => {
                this.boards[customer.uuid].push({
                    title: col.name,
                    id: col.id,
                    status_id: col.status.id,
                    items: []
                });
            })
        })
    }

    async loadColumns() {
        for (const col of this.data.columns) {
            (document.querySelector(`.row[data-customer-id='DEFAULT'] .kanban-board[data-id='${col.id}'] .kanban-drag`) as HTMLElement).innerHTML = ``
        }

        for (const customer of this.customers) {
            let ticketnum = 0
            if (this.data.customers.map(c => c.uuid).indexOf(customer.uuid) !== -1) {
                for (const col of this.data.columns) {
                    const statusId = col.status.id
                    const tickets = await Utils.entity.getAll('tickets', null, {
                        status_id: statusId,
                        customer_id: customer.uuid
                    });
                    (document.querySelector(`.row[data-customer-id='${customer.uuid}'] .kanban-board[data-id='${col.id}'] .kanban-drag`) as HTMLElement).style.textAlign = "";
                    (document.querySelector(`.row[data-customer-id='${customer.uuid}'] .kanban-board[data-id='${col.id}'] .kanban-drag`) as HTMLElement).innerHTML = ``
                    ticketnum += tickets.data.length
                    if (tickets.data.length > 0) {
                        tickets.data.forEach((ticket: any) => {
                            this.kanbans[customer.uuid].addElement(col.id, {
                                id: ticket.id,
                                title: ticket.title_formatted,
                                category: ticket.ticket_category.name,
                                priority_name: ticket.priority.name,
                                priority_color: ticket.priority.color,
                                status: ticket.status.name,
                                date: `${new Date(Date.parse(ticket.created_at)).toLocaleDateString()}`,
                                assignee: ticket.assignee ? ticket.assignee.name : null,
                                assignee_pic: ticket.assignee ? ticket.assignee.picture : null
                            })
                        })
                    }
                }
            }

            if (ticketnum === 0) {
                (document.querySelector(`.row[data-customer-id='${customer.uuid}']`) as HTMLElement).classList.remove("d-flex");
                (document.querySelector(`.row[data-customer-id='${customer.uuid}']`) as HTMLElement).classList.add("d-none")
            } else {
                (document.querySelector(`.row[data-customer-id='${customer.uuid}']`) as HTMLElement).classList.add("d-flex");
                (document.querySelector(`.row[data-customer-id='${customer.uuid}']`) as HTMLElement).classList.remove("d-none")
            }
        }
    }

    styleTickets() {
        const kanbanItem = Array.from(document.querySelectorAll('.kanban-item')) as HTMLElement[];
        kanbanItem.forEach((el) => {
            const assigneeName = el.getAttribute("data-assignee");
            const assigneeImg = el.getAttribute("data-assignee_pic");
            const prioName = el.getAttribute("data-priority_name");
            const openDate = el.getAttribute("data-date");
            const prioColor = el.getAttribute("data-priority_color");
            const taskType = el.getAttribute("data-category");
            let html = `<div class="d-flex justify-content-between flex-wrap align-items-center mb-2">
    <div class="item-badges justify-content-between d-flex w-100">
        <div class="badge bg-label-primary">${taskType}</div>
        <div class="badge" style="background-color:${prioColor};color:#FFF">${prioName}</div>
    </div>
<span class="kanban-text">${el.textContent}</span>
<div class="d-flex justify-content-between align-items-center flex-wrap mt-2 w-100">
    <div class="d-flex justify-content-between d-flex w-100">
    <div class="item-badges">
        <div class="badge bg-label-secondary">${openDate}</div>
    </div>
    <div class="avatar-group d-flex align-items-center assigned-avatar">
        
            <div class="avatar avatar-xs w-px-26 h-px-26" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="${assigneeName}" data-bs-original-title="${assigneeName}">
                <img src="${assigneeImg}" alt="${assigneeName}" class="rounded-circle pull-up">
            </div>
    </div>
</div>`
            el.innerHTML = html;
        });

        const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.forEach(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

        const tasksItemDropdown = Array.from(document.querySelectorAll('.kanban-tasks-item-dropdown')) as HTMLElement[];
        tasksItemDropdown.forEach((e) => {
            e.addEventListener('click', (el: Event) => {
                el.stopPropagation();
            });
        });
        const deleteTask = Array.from(document.querySelectorAll('.delete-task')) as HTMLElement[];
        deleteTask.forEach((elem) => {
            elem.addEventListener('click', (e: any) => {
                const id = elem.closest('.kanban-item')?.getAttribute('data-eid');
                Object.values(this.kanbans).forEach((kanban: any) => {
                    kanban.removeElement(id);
                })
            });
        });
    }

    async getCustomers() {
        const d = await Utils.entity.getAll("customers");
        if (d.status === 200) {
            this.customers = d.data.sort((a: any, b: any) => a.name - b.name)
        }
    }

    async updateEntity(data: any): Promise<void> {
        const main = document.querySelector("#kanban_main") as HTMLElement;
        main.classList.add("d-none")
        await super.updateEntity(data);
        await this.getCustomers();
        this.generateBoardInfo()
        await this.setupBoard();
        await this.loadColumns();
        this.styleTickets();
        jQuery("#ticketBoardConfigBoardForm #board_customers").val("").trigger("change");
        data.customers.forEach((customer: any) => {
            const $newOption = jQuery("<option selected='selected'></option>").val(customer.uuid).text(customer.name)
            jQuery("#ticketBoardConfigBoardForm #board_customers").append($newOption).trigger('change');
        })
        main.classList.remove("d-none")
    }
}